import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Privacy from '../views/Privacy.vue'
import AdditionalInfo from '../views/AdditionalInfo.vue'
import Incident from '../views/Incident.vue'
import AdminDashboard from "../views/admin/Dashboard.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import firebase from "firebase/app"
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'general.home',
    component: Home,
    meta: { public: true }
  },
  {
    path: '/login',
    name: 'auth.login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/logout',
    name: 'auth.logout',
    component: Logout,
    meta: { public: true }
  },
  {
    path: '/additional/:registration',
    name: 'submission.additional_info',
    props: true,
    component: AdditionalInfo,
    meta: { public: true }
  },
  {
    path: '/incident/:registration',
    name: 'submission.incident_description',
    props: true,
    component: Incident,
    meta: { public: true }
  },
  {
    path: '/about',
    name: 'general.about',
    component: About,
    meta: { public: true }
  },
  {
    path: '/privacy',
    name: 'general.privacy',
    component: Privacy,
    meta: { public: true }
  },
  {
    path: '/admin',
    name: 'admin.dashboard',
    component: AdminDashboard,
    meta: { public: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Redirect any nonprotected resources
router.beforeEach(async (to, from, next) => {
  const public_route = to.matched.some(record => record.meta.public);
  // var user = await firebase.getCurrentUser()

  var user = store.getters.current_user
  console.debug("Router:", to, user)

  if (!public_route ){
    if(!user) {
      console.debug("No user ")
      next('/login?redirect_to='+to.fullPath);
    } else {
      console.debug("Checking Firebase for ", user && user.uid)
      firebase.database().ref('/admins/' + user.uid).once('value',snapshot => {
        if(snapshot.exists() && snapshot.val()) {
          console.debug("Permission for ", user && user.uid)
          next()
        } else {
          console.error("No permission for ", user && user.uid)
          next('/')
        }
      }).catch( error => {
        console.error("Error:",error)
      })
    }
    
  } else {
    console.debug("Public Route")
    next();
  }
});

export default router


// Router use store for login check, problems
